import { useMutation } from '@tanstack/react-query';

import { useQueryInvalidation } from '@pkg/hooks';

import { USER_WALLETS_BY_USER_CACHE } from '../useWalletsQueryById';

import { callHideCollectibles, callShowCollectibles } from './request';
import { type HideCollectiblesParams, type ShowCollectiblesParams } from './request.types';

export function useToggleCollectiblesMutation() {
    const invalidateWalletsCache = useQueryInvalidation([USER_WALLETS_BY_USER_CACHE]);
    const { mutateAsync: hideTokens } = useMutation(
        (params: HideCollectiblesParams) => callHideCollectibles({ variables: params }),
        {
            onSuccess: invalidateWalletsCache,
        },
    );

    const { mutateAsync: showTokens } = useMutation(
        (params: ShowCollectiblesParams) => callShowCollectibles({ variables: params }),
        {
            onSuccess: invalidateWalletsCache,
        },
    );
    return {
        hideTokens,
        showTokens,
    };
}
